import React from "react";
import Header from '../inc/Header';
import Certificate from "../images/certificate.jpg";
import Masterdata from "../images/datamaster.jpg";
import ScrollToTop from "react-scroll-to-top";

function Linkage (){
    return(
        <>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <ScrollToTop smooth top="20" color="Darkblue" />
        <center>
            <h2 style={{color:"Gray"}}><b>LINKAGES AUTHORIZATION</b></h2>
        </center>
        <div className="album py-3">
        
        <div className="container">

            <div className="row">
       
            <div className="col-md-12" >
                         
            <div className="d-flex justify-content-between align-items-center">
                                <div className="card mb-4 me-3 border-white box shadow">
                           
                            <div class="card-body">
                          
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
<img src={Certificate} className="card-img-top"   alt="Certificate" />
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Govt. of India Certificate</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      <img src={Certificate} className="card-img-top"   alt="Certificate" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
       
      </div>
    </div>
  </div>
</div>
              
              <br/>
              <br/>
                              <center>
    <h5 style={{color: "Gray"}}className="card-title">Karimpur Netzone Private Limited</h5>
    </center>
                                            </div>
                         
                         
                            </div>
                            <div className="card mb-4 me-3 border-white box shadow">
                           
                            <div class="card-body">
                            
<button type="button" class="btn btn-warning" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
<img src={Masterdata} className="card-img-top"   alt="Masterdata" />
</button>


<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Company Master Data</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      <img src={Masterdata} className="card-img-top"   alt="Masterdata" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
       
      </div>
    </div>
  </div>
</div>
<br/>
<br/>

                            <center>
    <h5 style={{color: "Gray"}}className="card-title"> Karimpur Netzone Private Limited</h5>
    </center>
                                            </div>
                         
                         
                            </div>
                            
                          
                            </div>

                </div>
                </div>
                
                </div>
                </div>
                <hr/>
          
        </>
    );
}

export default Linkage;